module.exports = __webpack_public_path__ + "img/person-two.0c11f036.png";